import React from "react";
import { string } from "prop-types";
import SubSectionHeading from "../../atoms/SubSectionHeading";
import SectionParagraph from "../../atoms/SectionParagraph";

import "./sub-section-card.m.css";

const SubSectionCard = ({ title, content, ...props }) => {
  return (
    <div styleName="sub-section-card" {...props}>
      <SubSectionHeading>{title}</SubSectionHeading>
      <div styleName="content">
        <SectionParagraph>{content}</SectionParagraph>
      </div>
    </div>
  );
};

SubSectionCard.propTypes = {
  title: string.isRequired,
  content: string.isRequired
};

export default SubSectionCard;